import { WSMessage } from './ws-message';
import { AppDataActions } from '../../redux/app-data';

/**
 * @property {KLiveEventOpenedMessage} message
 */
export class LiveEventOpenedMessage extends WSMessage {

  isRelevant(/*state*/) {
    if (this.message.leo) {
      const eventDetails = this.message.leo.liveEvent ? this.message.leo.liveEvent : null;
      const sport = this.message.leo.group && this.message.leo.group.groups && this.message.leo.group.groups.length ? this.message.leo.group.groups[0] : null;
      this.actions.push(AppDataActions.addLiveEvent({ eventDetails, sport }));
      return true;
    }
    return false;
  }
}
